import moment from 'moment/moment'

import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'

type ReviewBaseConstructorArgs = ConstructorArgs<() => ReviewBase>

export abstract class ReviewBase extends BaseRecord {
    rating: number = 0
    memo?: string
    response?: string
    responseDate: moment.Moment | undefined

    abstract get reviewerName(): string
    abstract get responderName(): string

    abstract readonly recordType: string

    constructor(data?: Partial<ReviewBaseConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.rating = this.propertyFromIntArg(data.rating) ?? 0
        this.memo = data.memo ?? undefined
        this.response = data.response ?? undefined
        this.responseDate = this.propertyFromTimestampArg(data.response_date)
    }

    deserialize(data: any): void {
        super.deserialize(data)

        this.responseDate = moment(data.responseDate)
    }
}
